import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CargandoService } from '@nucleo/servicios/cargando-servicio';
import { DiccionarioIdiomas } from '@nucleo/i18n/traduccion-util';
import { NavegacionServicio } from '@nucleo/navegacion/navegacion-servicio';
import { BarraSuperior } from '../barra-superior/barra-superior';
import { MenuLateral } from '../menu-lateral/menu-lateral';

/** Clave de `route.data` con el nombre del módulo en cada idioma (`{ es, en }`), que se muestra mientras se descarga. */
const CLAVE_DATO_NOMBRE_MODULO = 'nombre';

/** Layout privado: barra superior + menú lateral + área de contenido. */
@Component({
  selector: 'app-contenedor-principal',
  imports: [
    RouterOutlet,
    BarraSuperior,
    MenuLateral,
    ProgressSpinnerModule,
  ],
  templateUrl: './contenedor-principal.html',
  styleUrl: './contenedor-principal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContenedorPrincipal {
  protected readonly servicioCargando = inject(CargandoService);

  constructor() {
    // El layout privado se crea al entrar con sesión: en ese momento se trae el menú del usuario.
    inject(NavegacionServicio).cargarMenu();

    // Muestra el indicador mientras se descargan los módulos diferidos (lazy loading).
    inject(Router)
      .events.pipe(takeUntilDestroyed())
      .subscribe((evento) => {
        if (evento instanceof RouteConfigLoadStart) {
          this.servicioCargando.iniciarCargaModulo(
            evento.route.data?.[CLAVE_DATO_NOMBRE_MODULO] as DiccionarioIdiomas<string> | undefined,
          );
        } else if (
          evento instanceof RouteConfigLoadEnd ||
          evento instanceof NavigationEnd ||
          evento instanceof NavigationError ||
          evento instanceof NavigationCancel
        ) {
          this.servicioCargando.finalizarCargaModulo();
        }
      });
  }
}
